module.exports = __webpack_public_path__ + "static/media/r_dot_12.df1d3c8c.png";